import { IGridPosition } from '../../../components/DndGrid';
import {
  IAnalysisPrefInput,
  IAnalysisSummaryInfoFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import { ContentSplitResult } from '../../../components/Scratchpad/ScratchpadContent/useContentSplit';

export enum ModalSliceType {
  // Schedule
  CreateSchedule = 'CREATE_SCHEDULE',
  ExecuteSchedule = 'EXECUTE_SCHEDULE',
  DeleteSchedule = 'DELETE_SCHEDULE',
  EditSchedule = 'EDIT_SCHEDULE',
  CohortImportToBraze = 'COHORT_IMPORT_TO_BRAZE',

  // workspaces
  WorkspaceEdit = 'WORKSPACE_EDIT',
  WorkspaceDelete = 'WORKSPACE_DELETE',
  WorkspaceDeleteReport = 'WORKSPACE_DELETE_REPORT',

  // dashboard
  DashboardDuplicate = 'DASHBOARD_DUPLICATE',
  DashboardDelete = 'DASHBOARD_DELETE',
  DashboardFolderDelete = 'DASHBOARD_FOLDER_DELETE',
  DashboardMove = 'DASHBOARD_MOVE',
  DashboardPublish = 'DASHBOARD_PUBLISH',
  DashboardUnpublish = 'DASHBOARD_UNPUBLISH',
  DashboardDeleteReport = 'DASHBOARD_DELETE_REPORT',
  DashboardDuplicateReport = 'DASHBOARD_DUPLICATE_REPORT',
  DashboardRemoveFilter = 'DASHBOARD_REMOVE_FILTER',

  // incidents
  IncidentDelete = 'INCIDENT_DELETE',
  IncidentCreate = 'INCIDENT_CREATE',
  IncidentShowMore = 'INCIDENT_SHOW_MORE',
  EditCalendarIncident = 'EDIT_CALENDAR_INCIDENT',

  // cohorts
  SaveCohort = 'SAVE_COHORT',
  SaveCohortRow = 'SAVE_COHORT_ROW',
  SaveCohortFromAnalysisId = 'SAVE_COHORT_FROM_ANALYSIS_ID',

  // named entities
  DisableVirtualEvent = 'DISABLE_VIRTUAL_EVENT',
  SaveMeasure = 'SAVE_MEASURE',
  DeleteMeasure = 'DELETE_MEASURE',
  SaveBucketDef = 'SAVE_BUCKET_DEF',
  DeleteNamedFilter = 'DELETE_NAMED_FILTER',
  DeleteCohort = 'DELETE_COHORT',

  // admins
  DisableUser = 'DISABLE_USER',
  EnableUser = 'ENABLE_USER',
  DisableUserGroup = 'DISABLE_USER_GROUP',
  EnableUserGroup = 'ENABLE_USER_GROUP',
  DisableRole = 'DISABLE_ROLE',
  EnableRole = 'ENABLE_ROLE',
  UserInviteNewUsers = 'USER_INVITE_NEW_USERS',
  UserInviteResend = 'USER_INVITE_RESEND',
  RevokeUser = 'REVOKE_USER',

  // reports
  ShowSql = 'SHOW_SQL',
  AddToDashboard = 'ADD_TO_DASHBOARD',
  AddToWorkspace = 'ADD_TO_WORKSPACE',
  RenameReport = 'RENAME_REPORT',
  DuplicateReport = 'DUPLICATE_REPORT',
  SaveConfirmModal = 'SAVE_CONFIRM_MODAL',
  ReportsSearch = 'REPORTS_SEARCH',
  DashboardsSearch = 'DASHBOARDS_SEARCH',
  CohortsSearch = 'COHORTS_SEARCH',

  // tiles
  DeleteTile = 'DELETE_TILE',
  UpsertTile = 'UPSERT_TILE',

  DeleteBucket = 'DELETE_BUCKET',

  // scratchpad
  DeleteScratchpad = 'DELETE_SCRATCHPAD',
  DeleteScratchpadNote = 'DELETE_SCRATCHPAD_NOTE',
  AddToScratchpad = 'ADD_TO_SCRATCHPAD',

  // conversations
  DeleteThreadComment = 'DELETE_THREAD_COMMENT',

  // lumos
  ConfigureLumos = 'CONFIGURE_LUMOS',
}

export interface IDashboardDuplicateReportData {
  analysisId: string;
  display: string;
  description: string;
  pref: IAnalysisPrefInput;
}

export interface IDashboardDeleteReportData {
  analysisId: string;
  position: IGridPosition;
}

export interface ICohortModalData {
  onSubmit: (cohortId: string, split: ContentSplitResult) => Promise<void>;
  split: ContentSplitResult;
}

export interface IDashboardModalData {
  onSubmit: (dashboardId: string, split: ContentSplitResult) => Promise<void>;
  split: ContentSplitResult;
}

export interface IReportModalData {
  onSubmit: (
    analysis: IAnalysisSummaryInfoFieldsFragment,
    split: ContentSplitResult,
  ) => Promise<void>;
  split: ContentSplitResult;
}

export interface IDeleteScratchpadModalData {
  scratchpadId: string;
}

export interface IDeleteScratchpadNoteModalData {
  scratchpadId: string;
  noteId: string;
}

export interface IModalSliceState {
  type: ModalSliceType | '';
  data?: ICohortModalData | IDashboardModalData | IReportModalData | any;
  id?: string;
}
